export default __webpack_public_path__ + "static/media/Community-Black.e2b16aa0.svg";